import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  optiongroups: PropTypes.any,
  optiongroup: PropTypes.any,
  onSave: PropTypes.func,
};

class ViewOptionGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let optiongroup = nextProps.optiongroup;
    if (optiongroup.id) {
      optiongroup = nextProps.optiongroup;
    } else {
      optiongroup = nextProps.optiongroups.results[0];
    }
    optiongroup.id = (optiongroup.id === null) ? 0 : optiongroup.id;
    this.setState({ optiongroup });
  }
  navigateToEdit() {
    browserHistory.push(`/optiongroups/${this.props.optiongroup.id}`);
  }
  handleCancel() {
    browserHistory.push('/optiongroups');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div>
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Edit"
              primary
              onClick={this.navigateToEdit}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.optiongroups.optiongroup.id}
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.optiongroups.optiongroup.name}
            style={styles.inputStyle}
            name="name"
          />
        </div>
      </div>
    );
  }
}

ViewOptionGroup.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewOptionGroup.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    optiongroups: state.optiongroups,
    optiongroup: state.optiongroups.optiongroup,
  };
}

export default connect(mapStateToProps)(ViewOptionGroup);



// WEBPACK FOOTER //
// ./src/components/optiongroups/ViewOptionGroup.js